import React from "react";
import { View, FlatList } from "react-native";
import ItemChoices from "./ItemChoices";
import ItemCheckbox from "./ItemCheckbox";
import type { OptionsType } from "@/app/types/option";
import { itemOptionsStyles as styles } from "./styles";
import { Text } from "../../Text";
import { useTranslateText } from "@/app/utils/translations";

type ItemOptionsProps = {
  lineItemId: number;
  defaultOptions: OptionsType[];
};

const renderOption = ({
  item,
  lineItemId,
}: {
  item: OptionsType;
  lineItemId: number;
}) => {
  return item.multipleChoices || item.choices.length === 1 ? (
    <View style={styles.choiceListContainer}>
      <ItemChoices
        lineItemId={lineItemId}
        optionId={item.id}
        choices={item.choices}
        optionTitle={item.name}
      />
    </View>
  ) : (
    <ItemCheckbox
      lineItemId={lineItemId}
      optionId={item.id}
      choices={item.choices}
      optionTitle={item.name}
    />
  );
};

const ItemOptions = ({
  lineItemId,
  defaultOptions,
}: ItemOptionsProps): JSX.Element => {
  const { t } = useTranslateText();
  return (
    <FlatList
      keyExtractor={({ id }) => `${id}`}
      ListHeaderComponent={
        <View style={styles.optionHeaderContainer}>
          <Text style={styles.optionHeader}>
            {t("tpos.productArea.specialOrder")}
          </Text>
        </View>
      }
      contentContainerStyle={styles.optionContainer}
      data={defaultOptions}
      renderItem={({ item }) => renderOption({ item, lineItemId })}
    />
  );
};

export default ItemOptions;
